import { Component } from '@angular/core';

import {AlertController, App, NavController} from 'ionic-angular';
import { ModalController, ViewController, ToastController } from 'ionic-angular';

import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../../providers/user-data';
import {UiData} from "../../../../providers/ui-data";
import { CvAddForm } from '../form/cvform';
import {Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import {HomePage} from "../../../home/home";


@Component({
    selector: 'page-certificates',
    templateUrl: 'certificates.html'
})
export class CvCertificatesPage {
    certificatesList: any;
    formationsRef: any;
    experiencesRef: any;
    certificatesRef: any;
    languagesRef: any;
    formations: Observable<any[]>;
    experiences: Observable<any[]>;
    certificates: Observable<any[]>;
    languages: Observable<any[]>;
    empty:boolean=true;

    /*    formationsData: any;
        experiencesData: any;
        certificatesData: any;
        languagesData: any;*/

    constructor(
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
        public afDatabase: AngularFireDatabase,
        private formBuilder: FormBuilder,
        public modalCtrl: ModalController,
        public toastCtrl: ToastController,
        public app: App

    ) {
        this.certificatesList = {};
        //userData.setToken('nova2');
        this.certificatesList['certificate'] = uiData.certificatesList();
        this.certificatesList['permis']  = uiData.permisList();
    }
    back(event)
    {

        try{
            this.app.getRootNav().setRoot(HomePage);
            this.app.getRootNav().popToRoot();
        }catch(e){}
    }
    ngAfterViewInit() {

        var that = this;
        that.userData.userSession().subscribe(session => {
            if (session !== null) {
                that.userData.load().subscribe(user => {
                    that.formationsRef = that.userData.getUserDbListReference('formations');
                    that.experiencesRef = that.userData.getUserDbListReference('experiences');
                    that.certificatesRef = that.userData.getUserDbListReference('certificates');
                    that.languagesRef = that.userData.getUserDbListReference('languages');

                    that.formations = that.formationsRef.valueChanges();
                    that.experiences = that.experiencesRef.valueChanges();
                    that.certificates = that.certificatesRef.valueChanges();
                    that.languages = that.languagesRef.valueChanges();
                    that.certificates.subscribe(function(data){
                        that.empty = data.length==0;
                    });
                });
            }
        });




        /*this.userData.getToken().then(function(token){

            that.formationsRef = that.afDatabase.list('/users/'+token+'/formations');
            that.experiencesRef = that.afDatabase.list('/users/'+token+'/experiences');
            that.certificatesRef = that.afDatabase.list('/users/'+token+'/certificates');
            that.languagesRef = that.afDatabase.list('/users/'+token+'/languages');

            that.formations = that.formationsRef.valueChanges();
            that.experiences = that.experiencesRef.valueChanges();
            that.certificates = that.certificatesRef .valueChanges();
            that.languages = that.languagesRef.valueChanges();
        });*/
    }

    /****
     * Add or update Formation
     * Use Modal controller with parameters
     ****/
    addFormationModal() {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "formations", ref:this.formationsRef, object: null });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Formation ajoutée.');
                this.userData.triggerPortalSync({});
            }
            else
            {
                //this.toastSuccess('Opération annulée.');
            }
        });
        profileModal.present();
    }
    updateFormationModal(object) {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "formations", ref:this.formationsRef, object: object });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Formation modifiée.');
                this.userData.triggerPortalSync({});
            }
            else
            {
                //this.toastSuccess('Opération annulée.');
            }
        });
        profileModal.present();
    }
    /****
     * Add or update Experience
     * Use Modal controller with parameters
     ****/
    addExperienceModal() {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "experiences", ref:this.experiencesRef, object: null });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Expérience ajoutée.');
                this.userData.triggerPortalSync({});
            }
            else
            {
                //this.toastSuccess('Opération annulée.');
            }
        });
        profileModal.present();
    }
    updateExperienceModal(object) {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "experiences", ref:this.experiencesRef, object: object });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Expérience modifiée.');
                this.userData.triggerPortalSync({});
            }
            else
            {
                //this.toastSuccess('Opération annulée.');
            }
        });
        profileModal.present();
    }
    /****
     * Add or update Certificate
     * Use Modal controller with parameters
     ****/
    addCertificateModal() {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "certificates", ref:this.certificatesRef, object: null });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Certificat/Permis ajouté.');
                this.userData.triggerPortalSync({});
            }
            else
            {

            }
        });
        profileModal.present();
    }
    updateCertificateModal(object) {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "certificates", ref:this.certificatesRef, object: object });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Certificat/Permis modifié.');
                this.userData.triggerPortalSync({});
            }
            else
            {

            }
        });
        profileModal.present();
    }
    /****
     * Add or update Certificate
     * Use Modal controller with parameters
     ****/
    addLanguageModal() {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "languages", ref:this.languagesRef, object: null });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Langue ajoutée.');
                this.userData.triggerPortalSync({});
            }
            else
            {

            }
        });
        profileModal.present();
    }
    updateLanguageModal(object) {
        let profileModal = this.modalCtrl.create(CvAddForm, { mode: "languages", ref:this.languagesRef, object: object });
        profileModal.onDidDismiss(data => {
            if(data.success)
            {
                this.toastSuccess('Langue modifiée.');
                this.userData.triggerPortalSync({});
            }
            else
            {

            }
        });
        profileModal.present();
    }

    /***
     * Toast management
     * @param {string} message
     */

    toastSuccess(message: string)
    {
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }
    toastCancel(message: string)
    {
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    removeExperience(experience)
    {
        var that = this;
        that.userData.update('experiences/'+experience.key,'disabled',true);
    }
    removeLanguage(language)
    {
        var that = this;
        that.userData.update('languages/'+language.key,'disabled',true);
    }
    removeCertificate(certificate)
    {
        var that = this;
        that.userData.update('certificates/'+certificate.key,'disabled',true);
    }
    removeFormation(formation)
    {
        var that = this;
        that.userData.update('formations/'+formation.key,'disabled',true);
    }
    swipe(event)
    {
        if(event.direction === 2) {
            this.nav.parent.select(3);
        }
        if(event.direction === 4) {
            this.nav.parent.select(1);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/cv/certificates/certificates.ts